import {ITemplateCacheService} from "angular";

export const DATE_PICKER_DAY_TEMPLATE = `
    <table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">
        <thead>
            <tr>
                <th>
                    <button type="button" class="btn btn-default btn-sm pull-left uib-left" ng-click="move(-1)" tabindex="-1">
                        <i aria-hidden="true" class="glyphicon glyphicon-chevron-left"></i><span class="sr-only">previous</span>
                    </button>
                </th>

                <th colspan="{{::5 + showWeeks}}">
                    <button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true"
                        type="button" class="btn btn-default btn-sm uib-title" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1">
                        <strong>
                            {{ "months." + title.trim().split(' ')[0].toUpperCase() | translate }}
                            {{ title.trim().split(' ')[1] }}
                        </strong>
                    </button>
                </th>
                <th>
                    <button type="button" class="btn btn-default btn-sm pull-right uib-right" ng-click="move(1)" tabindex="-1">
                        <i aria-hidden="true" class="glyphicon glyphicon-chevron-right"></i><span class="sr-only">next</span>
                    </button>
                </th>
            </tr>

            <tr>
                <th ng-if="showWeeks" class="text-center"></th>
                <th ng-repeat="label in ::labels track by $index" class="text-center">
                    <small aria-label="{{ "days." + label.full.trim().toUpperCase() | translate }}">
                        {{ "days-short." + label.abbr.trim().toUpperCase() | translate }}
                    </small>
                </th>
            </tr>
        </thead>

        <tbody>
            <tr class="uib-weeks" ng-repeat="row in rows track by $index" role="row">
                <td ng-if="showWeeks" class="text-center h6">
                    <em>{{ weekNumbers[$index] }}</em>
                </td>

                <td ng-repeat="dt in row" class="uib-day text-center" role="gridcell"
                    id="{{::dt.uid}}"
                    ng-class="::dt.customClass">

                    <button type="button" class="btn btn-default btn-sm"
                        uib-is-class="
                        'btn-info' for selectedDt,
                        'active' for activeDt
                        on dt"
                        ng-click="select(dt.date)"
                        ng-disabled="::dt.disabled"
                        tabindex="-1">
                        <span ng-class="::{'text-muted': dt.secondary, 'text-info': dt.current}">{{::dt.label}}</span>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
`;

/** @ngInject */
export function datePickerDayTemplateCaching($templateCache: ITemplateCacheService) {
    $templateCache.put("uib/template/datepicker/day.html", DATE_PICKER_DAY_TEMPLATE);
}
